import {
  Button,
  Card,
  CardContent,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Account from "../../../utils/apiConfig";
import ApiServices from "../../../service/apiService";
import { FetchAllUsers, UserCoursesModel, UserViewModel } from "@mikros/library";
import ErrorHandler from "../../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

export interface SearchFilterProps {
  // userDataCont: UserViewModel[];
  // userDataContFunction: Function;

  // userDataCont: UserCoursesModel;
  userDataCont: FetchAllUsers;
  userDataContFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  search: boolean;
  searchFunction: Function;
  formData: any;
  formDataFunction: Function;
  hasMoreData?: Boolean;
  hasMoreDataFunction: Function;
}
export function SearchFilterDup(props: SearchFilterProps) {
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();
  const intl = useIntl();
  const nameRegex: RegExp = new RegExp(/^[a-zA-Z\s.]+$/);
  const workRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.-]+$/);
  const maxUserNameLimit = 50;
  const maxCharLimit = 50;
  const validators = {
    userNameValidator: (value: string) =>
      value === "" || nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "analytics.userView.userNameValidation",
          })}`,

    deptRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.departmentValidation",
          })}`,
    desgRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.designationValidation",
          })}`,
    branchRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.branchValidation" })}`,
    locationRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.locationValidation" })}`,
  };
  // const [formData, setFormData] = useState({
  //   firstName: "",
  //   branchName: "",
  //   department: "",
  //   location: "",
  //   designation: "",
  // });

  const [searchClicked, setSearchClicked] = useState<boolean>(false);

  const [errors, setErrors] = useState<Record<string, string>>({}); // Ensure it's an object

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("error code flag value print", errorFlag);

  console.log("user data cont in search filter", props?.userDataCont);

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    console.log("Inside handle search:", props.formData);

    // Check if at least one field has data
    const hasValidInput = Object.values(props.formData).some(
      (value) => typeof value === "string" && value.trim() !== ""
    );

    if (!hasValidInput) {
      console.log("No search fields filled. Skipping API call.");
      return; //  Skip API call if all fields are empty
    }

    setSearchClicked(true);

    //  Build the query string dynamically
    const filters = [
      "firstName",
      "branchName",
      "department",
      "location",
      "designation",
    ];
    const queryParams = filters
      .filter((key) => props.formData[key]?.trim()) // Only include non-empty fields
      .map((key) => `${key}=${encodeURIComponent(props.formData[key].trim())}`) // Encode special characters
      .join("&");

    console.log("Query String:", queryParams);

    const api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      // api
      //   .makeRequest(
      //     `${accountInstance.accntId}/analytics/useranalytics/filter?${queryParams}`,
      //     "GET"
      //   )
      api
        .makeRequest(
          `${accountInstance.accntId}/user/filter?${queryParams}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props?.userDataContFunction(data);
            props.totalCountFunction(data.users.length);
            props.searchFunction(true);
            const hasDataLeft = data?.lastKey !== null;
            props.hasMoreDataFunction(hasDataLeft);
          }
        });
    }
  };

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    props.formDataFunction({
      ...props.formData,
      [name]: value,
    });

    console.log("inside handl change name", name);
    console.log("inside handle change value", value);
    // Validate and keep the error until the entire input is valid
    // const errorMsg = validators.userNameValidator(value);
    let errorMsg = "";
    if (name === "firstName") {
      console.log("inside user name validator");
      errorMsg = validators.userNameValidator(value);
    } else if (name === "branchName") {
      console.log("inside branch validator");
      errorMsg = validators.branchRegexValidator(value);
    } else if (name === "department") {
      console.log("inside dept validator");
      errorMsg = validators.deptRegexValidator(value);
    } else if (name === "location") {
      console.log("inside location validator");
      errorMsg = validators.locationRegexValidator(value);
    } else if (name === "designation") {
      console.log("inside desg validator");
      errorMsg = validators.desgRegexValidator(value);
    }

    setErrors((prev: any) => ({
      ...prev,
      [name]: errorMsg, // Only update the specific field
    }));
  };

  const handleClearAll = () => {
    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
    });
    setErrors({});

    if (searchClicked) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        //   api
        //     .makeRequest(
        //       // `${accountInstance.accntId}/analytics/useranalytics/filter`,
        //       `${accountInstance.accntId}/analytics/useranalytics?limit=20`,
        //       "GET"
        //     )
        api
          .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log("I entered error code handling in users");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              props?.userDataContFunction(data);
              props.totalCountFunction(data.users.length);
              // props.searchFunction(true);
              props.searchFunction(false);
              props.hasMoreDataFunction(true);
            }
          });
      }
      setSearchClicked(false); // Reset the search click status
    }
  };

  const handleClear = (field: string) => {
    // setFormData({
    //   ...formData,
    //   [field]: "",
    // });
    props.formDataFunction({
      ...props.formData,
      [field]: "",
    });

    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);
  return (
    <div>
      <Card sx={{ padding: 1, boxShadow: 3, borderRadius: 2 }}>
        <CardContent>
          <form onSubmit={handleSearch}>
            <div className="grid grid-cols-3 gap-4">
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* User Name */}
                  <FormattedMessage id="analytics.userView.userName" />
                </Typography>
                <TextField
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  InputLabelProps={{ shrink: false }}
                  name="firstName"
                  value={props.formData.firstName}
                  onChange={handleChange}
                  sx={{
                    "& input:-webkit-autofill, & input:-webkit-autofill:focus, & input:-webkit-autofill:hover, & input:-webkit-autofill:active":
                      {
                        WebkitBoxShadow: "0 0 0 1000px white inset !important", // Apply white background within bounds
                        WebkitTextFillColor: "black !important",
                        transition:
                          "background-color 9999s ease-out 0s !important",
                        height: "0.005rem !important",
                      },
                  }}
                  inputProps={{ maxLength: maxUserNameLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {props.formData.firstName && (
                          <IconButton
                            onClick={() => handleClear("firstName")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* Branch */}
                  <FormattedMessage id="analytics.userView.branch" />
                </Typography>
                <TextField
                  error={!!errors.branchName}
                  helperText={errors.branchName}
                  InputLabelProps={{ shrink: false }}
                  name="branchName"
                  value={props.formData.branchName}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {props.formData.branchName && (
                          <IconButton
                            onClick={() => handleClear("branchName")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* Department */}
                  <FormattedMessage id="analytics.userView.dept" />
                </Typography>
                <TextField
                  error={!!errors.department}
                  helperText={errors.department}
                  InputLabelProps={{ shrink: false }}
                  name="department"
                  value={props.formData.department}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {props.formData.department && (
                          <IconButton
                            onClick={() => handleClear("department")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* Location */}
                  <FormattedMessage id="analytics.userView.location" />
                </Typography>
                <TextField
                  error={!!errors.location}
                  helperText={errors.location}
                  InputLabelProps={{ shrink: false }}
                  name="location"
                  value={props.formData.location}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {props.formData.location && (
                          <IconButton
                            onClick={() => handleClear("location")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* Designation */}
                  <FormattedMessage id="analytics.userView.desg" />
                </Typography>
                <TextField
                  error={!!errors.designation}
                  helperText={errors.designation}
                  InputLabelProps={{ shrink: false }}
                  name="designation"
                  value={props.formData.designation}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {props.formData.designation && (
                          <IconButton
                            onClick={() => handleClear("designation")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <div className="flex justify-start items-center space-x-2">
                <Button
                  type="submit"
                  variant="contained"
                  disableRipple
                  sx={{
                    mt: 2,
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    color: "white",

                    backgroundColor: "#6464E5",
                    "&:hover": {
                      backgroundColor: "#E1E2E9",
                      color: "black",
                    },
                    display: "inline-block",
                  }}
                >
                  <FormattedMessage id="analytics.userView.search" />
                </Button>

                <Button
                  type="button" // Use 'button' type to prevent form submission
                  variant="contained"
                  disableRipple // Disable ripple effect
                  sx={{
                    mt: 2,
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    color: "black",

                    backgroundColor: "#E1E2E9",
                    "&:hover": {
                      backgroundColor: "#E1E2E9",
                    },

                    display: "inline-block",
                  }}
                  onClick={() => {
                    handleClearAll();
                  }}
                >
                  <FormattedMessage id="analytics.userView.clear" />
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                // navigate("/analytics");
                navigate("/reports");
              }
            }}
          />
        </Dialog>
      )}
    </div>
  );
}
